module.exports = __webpack_public_path__ + "img/FourthPerson.0efff37b.png";